import { Heading, NavigationTabs, NavigationTabsItem, Stack } from '@sixfold/common-ui';
import { Route, Routes as RouterRoutes, Navigate } from 'react-router';

import { IntercomContainer } from './intercom_container';
import { TransportAnalyzerContainer } from './transport_analyzer_container';
import { NotificationPreviewContainer } from '../../notification_preview';
import { OvdTokensContainer } from '../../ovd_token';
import { Routes } from '../../routes';

export const MiscellaneousContainer = () => {
  return (
    <Stack direction="column" gap="medium">
      <Heading size="large">Miscellaneous</Heading>
      <NavigationTabs>
        <NavigationTabsItem href={Routes.TransportAnalyzer.generatePath({})}>Transport Analyzer</NavigationTabsItem>
        <NavigationTabsItem href={Routes.Intercom.generatePath({})}>Intercom</NavigationTabsItem>
        <NavigationTabsItem href={Routes.NotificationPreviews.generatePath({})}>
          Notification Previews
        </NavigationTabsItem>
        <NavigationTabsItem href={Routes.OvdTokens.generatePath({})}>OVD Tokens</NavigationTabsItem>
      </NavigationTabs>
      <RouterRoutes>
        <Route path={Routes.TransportAnalyzer.relativePath} element={<TransportAnalyzerContainer />} />
        <Route path={Routes.Intercom.relativePath} element={<IntercomContainer />} />
        <Route path={Routes.NotificationPreviews.relativePath} element={<NotificationPreviewContainer />} />
        <Route path={Routes.OvdTokens.relativePath} element={<OvdTokensContainer />} />
        <Route index element={<Navigate to={Routes.TransportAnalyzer.generatePath({})} replace />} />
      </RouterRoutes>
    </Stack>
  );
};
